export enum CoreInfoRequestStatusEnum {
  WaitingCustomer = 0,
  Responded = 1,
  Accepted = 2,
}

export const GetCoreInfoRequestStatusEnum = [
  { Description: "WAITING FOR CUSTOMER", Value: CoreInfoRequestStatusEnum.WaitingCustomer },
  { Description: "RESPONDED", Value: CoreInfoRequestStatusEnum.Responded },
  { Description: "ACCEPTED", Value: CoreInfoRequestStatusEnum.Accepted },
];
